import React from "react";

import styles from "./atoms.Pagination.module.scss";
export class Pagination extends React.Component {

  setPageArray = (currentPage, pageQuantity) => {
    let firstIndex;
    if (pageQuantity <= 4) {
      return Array(pageQuantity)
        .fill(0)
        .map((v, i) => i + 1);
    }

    if (currentPage - 1 <= 0) {
      firstIndex = 1;
    } else {
      if (currentPage + 2 > pageQuantity) {
        firstIndex = pageQuantity - 3;
      } else {
        firstIndex = currentPage - 1;
      }
      
    }
    return Array(4)
        .fill(0)
        .map((v, i) => i + firstIndex);
  };

  render() {
    const { pageQuantity, currentPage, pageChangeHandler } = this.props;

    
    const arr = this.setPageArray(currentPage, pageQuantity);
    const last = arr[arr.length - 1];
    const first = arr[0];

    return (
      <div className={styles["pagination-container"]}>
        <div className={styles["pagination-numbers"]}>
          {first !== 1 && (
            <div
              className={`${styles["pagination-item"]} ${styles["pagination-dots"]} ${styles["izq"]}`}
              onClick={() => pageChangeHandler(1)}
              data-automation-id="pagination-first-page"
            >
              <i className={`icon-chevron-izquierda ${styles["pagination-icon"]}`}></i> ...{" "}
            </div>
          )}
          {
            arr.map((i) => {
              return (
                <div
               data-automation-id={"pagination-page-"+i}

                  key={i}
                  className={
                    currentPage === i
                      ? `${styles["pagination-item"]} ${styles["pagination-number"]} ${styles["active"]}`
                      : `${styles["pagination-item"]} ${styles["pagination-number"]}`
                  }
                  onClick={() => pageChangeHandler(i)}
                >
                  {i}
                </div>
              );
            })}
        </div>

        {pageQuantity !== last && (
          <div
            data-automation-id="pagination-last-page"

            className={`${styles["pagination-item"]} ${styles["pagination-dots"]}`}
            onClick={() => pageChangeHandler(pageQuantity)}
          >
            ...<i className={`icon-chevron-derecha ${styles["pagination-icon"]}`}></i>
          </div>
        )}
      </div>
    );
  }
}

Pagination.propTypes = {};

export default Pagination;
